import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hungry-elion-4/artifacts/ac0h19e4_KritvaSoftLogoOriginal-removebg-preview.png";

const navItems = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Services', href: '#services' },
  { name: 'Solutions', href: '#solutions' },
  { name: 'Careers', href: '#careers' },
  { name: 'Contact', href: '#contact' },
];

export const Header = ({ onOpenContactModal }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const handleNavClick = (e, href) => {
    if (!isHome) {
      e.preventDefault();
      const sectionId = href.replace('#', '');
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <header 
      data-testid="header-navigation"
      className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b"
      style={{ borderColor: '#E2E8F0' }}
    >
      <div className="kv-container">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a 
            href="/" 
            className="flex items-center"
            data-testid="nav-link-logo"
          >
            <img 
              src={LOGO_URL} 
              alt="KritvaSoft - Build. Automate. Grow." 
              className="h-10 lg:h-12 w-auto"
              width="140"
              height="48"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={isHome ? item.href : '/' + item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                data-testid={`nav-link-${item.name.toLowerCase().replace(' ', '-')}`}
                className="nav-link text-sm font-medium transition-colors duration-200"
                style={{ color: '#475569' }}
                onMouseEnter={(e) => e.target.style.color = '#0A3D91'}
                onMouseLeave={(e) => e.target.style.color = '#475569'}
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center">
            <button
              onClick={onOpenContactModal}
              data-testid="strategy-call-cta"
              className="kv-btn-primary"
            >
              Book a Strategy Call
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-md transition-colors"
            data-testid="mobile-menu-toggle"
            style={{ color: '#131B2E' }}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div 
            className="lg:hidden border-t py-4"
            style={{ borderColor: '#E2E8F0' }}
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col gap-4">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={isHome ? item.href : '/' + item.href}
                  onClick={(e) => { handleNavClick(e, item.href); setIsMobileMenuOpen(false); }}
                  data-testid={`mobile-nav-link-${item.name.toLowerCase().replace(' ', '-')}`}
                  className="text-sm font-medium py-2 transition-colors duration-200"
                  style={{ color: '#475569' }}
                >
                  {item.name}
                </a>
              ))}
              <button
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  onOpenContactModal();
                }}
                data-testid="mobile-strategy-call-cta"
                className="kv-btn-primary mt-2"
              >
                Book a Strategy Call
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
